import { reactive } from "vue";

export const ui = reactive({
  alerts: [], // queue of alerts

  addAlert(title, text, link = null, id) {
    this.alerts.push({
      id, // unique id
      title,
      text,
      link,
      show: true,
    });
  },

  removeAlert(id) {
    const index = this.alerts.findIndex((a) => a.id === id);
    if (index !== -1) this.alerts.splice(index, 1);
  },
});
